import { useCallback, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { apiUrl } from '../../../config/api'

export const useGoogleRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const [token, setToken] = useState('')

  const handleReCaptchaVerify = useCallback(
    async (action?: string) => {
      if (!executeRecaptcha) {
        return
      }

      const token = await executeRecaptcha(action || '')
      if (!token) return
      if (token) {
        setToken(token)
        apiUrl.defaults.headers.common['x-recaptcha-response'] = token
        if (action) {
          apiUrl.defaults.headers.common['x-expected-action'] = action
        } else {
          apiUrl.defaults.headers.common['x-expected-action'] = action
        }
      }
    },
    [executeRecaptcha]
  )

  return {
    handleReCaptchaVerify,
    token,
  }
}
